import React from 'react'
import { Button, Card, Row, Col } from 'antd'
import '../index.less'
import InfoList from './infoList'
import TableList from './tableList'

export default function Detail(props: any) {
  return (
    <div className="estateList">
      <InfoList {...props} />
      <div style={{ marginTop: 10 }}>
        <TableList {...props} />
      </div>
    </div>
  )
}
